import React, { useCallback } from "react";

import { Container, Nav, Navbar, Button, Badge } from "react-bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Link } from "react-router-dom";
import pdf from "../PDF/merged.pdf"

const Navigation = (props) => {
  //handle change of state selecting a new date
  const handleDateChange = (e) => {
    const selectedDate = [];
    for (var item in e) {
      selectedDate.push(e[item].value);
    }
    props.setDate(selectedDate);
  };

  //handle change of state selecting a new topic
  const handleTopicChange = (e) => {
    const selectedTopic = [];
    for (var item in e) {
      selectedTopic.push(e[item].value);
    }
    props.setTopic(selectedTopic);
  };

  const animatedComponents = makeAnimated();

  return (
    <div>
      <Navbar bg="light" expand="lg" style={{ height: "55px" }} fixed="top">
        <Container>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Navbar.Brand href="#home">
              Network Security Trainer
              <span style={{fontSize:"11px", position:"relative", top:"6px", left:"-12px"}}>
                <Badge pill bg="dark">beta</Badge>
              </span>
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse style={{background:"#F8F9FA"}} id="basic-navbar-nav">
            <Nav>
              <Link to="/saved" style={{ textDecoration: "none" }}>
                <Nav.Link href="#saved">Saved</Nav.Link>
              </Link>
              <div style={{ textDecoration: "none" }} >
                <Nav.Link className="text-secondary" href={pdf} download="Network Security Merged">PDF</Nav.Link>
              </div>
            </Nav>
            {props.parent === "index" ? (
              <Nav className="ms-auto">
                <Nav.Link style={{ marginTop: "-6px" }}>
                  <Select
                    components={animatedComponents}
                    defaultValue={[props.dateOptions[0]]}
                    isMulti
                    placeholder="Select Option"
                    options={props.dateOptions}
                    onChange={handleDateChange}
                  />
                </Nav.Link>
                <Nav.Link style={{ marginTop: "-6px" }}>
                  <Select
                    components={animatedComponents}
                    defaultValue={[props.topicOptions[0]]}
                    isMulti
                    options={props.topicOptions}
                    onChange={handleTopicChange}
                  />
                </Nav.Link>
                <Nav.Link style={{ marginTop: "-6px" }}>
                  <Button variant="dark" onClick={props.randomize}>
                    Random
                  </Button>
                </Nav.Link>
              </Nav>
            ) : (
              ""
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Navigation;